module.exports = __webpack_public_path__ + "static/media/xk.1351d331.svg";